import { render, staticRenderFns } from "./qingkaoChange.vue?vue&type=template&id=2fafc524&scoped=true"
import script from "./qingkaoChange.vue?vue&type=script&lang=js"
export * from "./qingkaoChange.vue?vue&type=script&lang=js"
import style0 from "./qingkaoChange.vue?vue&type=style&index=0&id=2fafc524&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fafc524",
  null
  
)

export default component.exports